import { jsxs as O, jsx as r } from "react/jsx-runtime";
import { useRef as Y, useState as W, useEffect as j, forwardRef as I, useMemo as P } from "react";
import { Theme as U, MLPVersion as x } from "./types/enums.js";
import { filterSearchIgnoreCase as K } from "./utils/index.js";
import { DropDownValidations as H, DropDownType as T, DropDownFilterBy as q } from "./components/DropDown/types/enums.js";
import J, { isDisabledItem as Q } from "./components/DropDown/mlp1/DropDownMLP1.js";
import X from "./components/DropDown/mlp2/DropDownMLP2.js";
import Z from "./components/DropDown/inline/inlineDropDown.js";
import oo from "./components/Tooltip/Tooltip.js";
import eo from "./components/Icons/Icons.js";
import ao from "./components/Checkbox/Checkbox.js";
import { useTranslation as ro } from "./components/Translation/TranslationProvider.js";
import no from "./hooks/useClickOutsideDetector.js";
import { TooltipPreference as to } from "./components/Tooltip/types/enums.js";
import './assets/DropDown.css';const lo = "#ffffff", io = "#396e75", so = "#e5fdff", co = "#546223", po = "#f0fae5", wo = "#a65523", _o = "#fff1e8", mo = "#7f3e3e", Vo = "#ffe2e2", fo = "#62625a", uo = "#f8f8e7", Co = "#38539a", zo = "#707070", $o = "#c8f8d1", ho = "#87c9c8", go = "#5291b1", ko = "rgba(82, 145, 177, 0.1019607843)", bo = "#445685", vo = "#181d61", yo = "rgba(24, 29, 97, 0.1019607843)", Bo = "#5969d6", Oo = "#ea999d", xo = "#b6577e", No = "rgba(182, 87, 126, 0.1019607843)", Go = "#7e3e80", Ro = "#1e247f", So = "rgba(30, 36, 127, 0.1019607843)", Wo = "#da7600", To = "#107f47", Lo = "#d91734", Ao = "_html_16493_75", Fo = "_disabled_16493_329", e = {
  amwayWhite: lo,
  darkBlue: io,
  lightBlue: so,
  darkGreen: co,
  lightGreen: po,
  darkOrange: wo,
  lightOrange: _o,
  darkRed: mo,
  lightRed: Vo,
  darkYellow: fo,
  lightYellow: uo,
  darkPurple: Co,
  darkGrayOnWhite: zo,
  dataVizColor1: $o,
  dataVizColor2: ho,
  dataVizColor3: go,
  dataVizColor3Background: ko,
  dataVizColor4: bo,
  dataVizColor5: vo,
  dataVizColor5Background: yo,
  dataVizColor6: Bo,
  dataVizColor7: Oo,
  dataVizColor8: xo,
  dataVizColor8Background: No,
  dataVizColor9: Go,
  dataVizColor10: Ro,
  dataVizColor10Background: So,
  dataVizAlertOrange: Wo,
  dataVizSuccessGreen: To,
  dataVizWarningRed: Lo,
  "no-visible": "_no-visible_16493_34",
  html: Ao,
  "focused-border": "_focused-border_16493_142",
  "dropdown-container": "_dropdown-container_16493_142",
  "base-dropdown-result": "_base-dropdown-result_16493_142",
  "open-dropdown-result": "_open-dropdown-result_16493_142",
  "dropdown-container-modal": "_dropdown-container-modal_16493_143",
  "dropdown-box": "_dropdown-box_16493_143",
  "dropdown-field-result": "_dropdown-field-result_16493_143",
  "list-view": "_list-view_16493_149",
  "dropdown-message": "_dropdown-message_16493_168",
  "dropdown-label": "_dropdown-label_16493_172",
  "dropdown-tool-tip": "_dropdown-tool-tip_16493_181",
  "dropdown-field": "_dropdown-field_16493_143",
  "dropdown-field-disable": "_dropdown-field-disable_16493_221",
  "dropdown-validated-valid": "_dropdown-validated-valid_16493_232",
  "dropdown-validated-invalid": "_dropdown-validated-invalid_16493_236",
  "dropdown-icon": "_dropdown-icon_16493_240",
  "icon-medium": "_icon-medium_16493_240",
  "icon-desktop": "_icon-desktop_16493_247",
  "base-dropdown-valid": "_base-dropdown-valid_16493_292",
  "base-dropdown-invalid": "_base-dropdown-invalid_16493_296",
  disabled: Fo,
  "dropdown-message-valid": "_dropdown-message-valid_16493_350",
  "dropdown-message-invalid": "_dropdown-message-invalid_16493_354",
  "disabled-container": "_disabled-container_16493_359"
}, Do = ({
  placeholder: V,
  dropdownLabel: h = "",
  message: g = "",
  className: k = "",
  labelInfo: _ = "",
  labelInfoPreference: s = to.RIGHT,
  disabled: n = !1,
  value: c = "",
  data: p = [],
  configData: d,
  status: t,
  name: b = "",
  testId: o = "dropdown",
  width: l,
  top: f,
  isWithinModal: v = !1,
  ariaLabel: u,
  onClick: C,
  ...z
}) => {
  const { DEFAULT: y } = H, N = Y(), [B, G] = W(!1), [$, R] = W([]), L = ro(), A = u || L("nextgen.Dropdown.ariaLabel"), F = (a) => {
    C && C(a), G((w) => !w);
  };
  j(() => {
    R(
      p.filter((a) => Array.isArray(c) && c.includes(a[d == null ? void 0 : d.label]))
    );
  }, [c]), no(N, () => G(!1));
  const D = {
    up: {
      icon: "chevron-up",
      iconClassName: "icon-medium"
    },
    down: {
      icon: "chevron-down",
      iconClassName: "icon-desktop"
    }
  }[B && !n ? "up" : "down"], { icon: E, iconClassName: M } = D, S = (a) => {
    const w = $.findIndex((m) => m.id === a.id);
    let i;
    w !== -1 ? i = $.filter((m) => m.id !== a.id) : i = [...$, a], R(i), d != null && d.onSelect && (d == null || d.onSelect(i));
  };
  return /* @__PURE__ */ O(
    "span",
    {
      className: `${e[v ? "dropdown-container-modal" : "dropdown-container"]} ${n ? e["disabled-container"] : ""} ${k}`,
      ref: N,
      "data-testid": `${o}-ref-text-id`,
      children: [
        /* @__PURE__ */ O("label", { className: e["dropdown-label"], "data-testid": `${o}-label`, children: [
          /* @__PURE__ */ r("span", { className: e["dropdown-label-text"], "data-testid": `${o}-label-text`, children: h }),
          _ && /* @__PURE__ */ r(oo, { message: _, preference: s, className: e["dropdown-tool-tip"] })
        ] }),
        /* @__PURE__ */ O(
          "div",
          {
            id: "dropdown-box",
            className: `${e["dropdown-box"]} ${B && !n && t === y ? e["dropdown-field-result"] : ""} ${t && t !== y && !n ? e[`dropdown-validated-${t}`] : ""}`,
            style: l ? { width: l } : {},
            onClick: F,
            onKeyDown: () => null,
            tabIndex: 0,
            role: "button",
            "aria-label": A,
            "data-testid": `${o}-section-test-id`,
            ...z,
            children: [
              /* @__PURE__ */ r(
                "input",
                {
                  name: b,
                  value: c,
                  placeholder: V,
                  readOnly: !0,
                  className: `${p.length > 0 ? e["dropdown-field"] : e["dropdown-field-disable"]}`,
                  disabled: n,
                  "data-testid": `${o}-test-id`
                }
              ),
              /* @__PURE__ */ r(
                eo,
                {
                  "data-testid": `${o}-icon-text-id`,
                  iconName: E,
                  className: `${e["dropdown-icon"]} ${n ? "" : e["dropdown-icon-disable"]} ${e[M]}`
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ r(
          "section",
          {
            className: `${e["base-dropdown-result"]} ${B && !n ? e["open-dropdown-result"] : ""} 
          ${t && t !== y && !n ? e[`dropdown-validated-${t}`] : ""}`,
            style: {
              ...l ? { width: l } : {},
              ...f ? { top: f } : {}
            },
            "data-testid": `${o}-results-test-id`,
            children: /* @__PURE__ */ r("ul", { children: p.map((a, w) => {
              const i = Q(a, d);
              return /* @__PURE__ */ r(
                "li",
                {
                  role: "presentation",
                  "data-testid": `${o}-li-element`,
                  className: `${i ? e.disabled : ""}`,
                  children: /* @__PURE__ */ r(
                    ao,
                    {
                      id: `${a.id}`,
                      text: a[d == null ? void 0 : d.label],
                      checked: $.some((m) => m.id === a.id),
                      disabled: i,
                      theme: U.BLACK,
                      "data-testid": `${o}-checkbox-${w}`,
                      onClick: () => S(a),
                      onKeyDown: () => S(a)
                    }
                  )
                },
                `dropdown${+w}`
              );
            }) })
          }
        ),
        !n && /* @__PURE__ */ r(
          "span",
          {
            role: "note",
            "aria-label": "message",
            "aria-details": `${d == null ? void 0 : d.label} input message`,
            className: `${e["dropdown-message"]} ${t && !n ? e[`dropdown-validated-${t}`] : ""}`,
            children: g
          }
        )
      ]
    }
  );
}, Eo = "#ffffff", Mo = "#396e75", Yo = "#e5fdff", jo = "#546223", Io = "#f0fae5", Po = "#a65523", Uo = "#fff1e8", Ko = "#7f3e3e", Ho = "#ffe2e2", qo = "#62625a", Jo = "#f8f8e7", Qo = "#38539a", Xo = "#707070", Zo = "#c8f8d1", oe = "#87c9c8", ee = "#5291b1", de = "rgba(82, 145, 177, 0.1019607843)", ae = "#445685", re = "#181d61", ne = "rgba(24, 29, 97, 0.1019607843)", te = "#5969d6", le = "#ea999d", ie = "#b6577e", se = "rgba(182, 87, 126, 0.1019607843)", ce = "#7e3e80", pe = "#1e247f", we = "rgba(30, 36, 127, 0.1019607843)", _e = "#da7600", me = "#107f47", Ve = "#d91734", fe = "_html_ootjf_75", ue = {
  amwayWhite: Eo,
  darkBlue: Mo,
  lightBlue: Yo,
  darkGreen: jo,
  lightGreen: Io,
  darkOrange: Po,
  lightOrange: Uo,
  darkRed: Ko,
  lightRed: Ho,
  darkYellow: qo,
  lightYellow: Jo,
  darkPurple: Qo,
  darkGrayOnWhite: Xo,
  dataVizColor1: Zo,
  dataVizColor2: oe,
  dataVizColor3: ee,
  dataVizColor3Background: de,
  dataVizColor4: ae,
  dataVizColor5: re,
  dataVizColor5Background: ne,
  dataVizColor6: te,
  dataVizColor7: le,
  dataVizColor8: ie,
  dataVizColor8Background: se,
  dataVizColor9: ce,
  dataVizColor10: pe,
  dataVizColor10Background: we,
  dataVizAlertOrange: _e,
  dataVizSuccessGreen: me,
  dataVizWarningRed: Ve,
  "no-visible": "_no-visible_ootjf_34",
  html: fe,
  "nextgen-dropdown-wrapper": "_nextgen-dropdown-wrapper_ootjf_142"
}, Ce = I(
  ({
    mlpVersion: V = x.TWO,
    multiSelection: h,
    dropDownType: g = T.DEFAULT,
    drawerParentOutside: k = !1,
    filterBy: _ = q.INCLUDES,
    ...s
  }, n) => {
    const { DEFAULT: c, MULTI_SELECT: p, INLINE: d } = T;
    let t = X;
    const b = h ? p : g, o = s, l = () => o.applySearchFilter === !0 && o.searchFilterValue ? o.searchFilterValue : V === x.TWO && !o.disabledFilter || o.isCountrySelector === !0 ? o.value : "", f = P(
      () => {
        var u;
        return l() ? (u = o.data) == null ? void 0 : u.filter(
          (C) => {
            var z;
            return K(`${C[`${(z = o.configData) == null ? void 0 : z.label}`]}`, l(), _);
          }
        ) : o.data;
      },
      [o.data, o.value, o.searchFilterValue, _]
    );
    V === x.ONE && (t = J);
    const v = {
      [c]: /* @__PURE__ */ r(t, { ...s, data: f }),
      [p]: /* @__PURE__ */ r(Do, { ...s }),
      [d]: /* @__PURE__ */ r(Z, { ...s })
    }[b];
    return /* @__PURE__ */ r(
      "span",
      {
        "data-testid": "dropdown-wrapper-test-id",
        "data-pod-name": "fwk",
        ref: n,
        id: "nextgen-dropdown-component",
        style: { position: k ? "static" : "relative" },
        className: ue["nextgen-dropdown-wrapper"],
        children: v
      }
    );
  }
);
Ce.displayName = "DropDown";
export {
  Ce as D,
  Do as M
};
//# sourceMappingURL=DropDown-e20f1bba.mjs.map
